import { Messages } from '../../../../codegen/Localize';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IRefreshExtractAction } from '../../../../ts/ServerApi/types/actionNames';
import { CreateExtractTasksMode } from '../../../../ts/services/CreateExtractTasksAction';
import { createExtractRefresh } from '../../../actions/spaces/CreateExtractRefreshAction';
import { IEntityAction } from './IEntityAction';
import { isSingleEmbeddedDatasource } from './IEntityActionHelpers';

export const RefreshExtractsAction: IEntityAction<IContentInfo, IRefreshExtractAction> = {
  name: 'refresh_extracts',
  translateName: Messages.extractTasks_action,
  isVisible: (targetItems: IContentInfo[]) => {
    return !isSingleEmbeddedDatasource(targetItems);
  },
  isClickable: (availableActions: IRefreshExtractAction, targetItems: IContentInfo[]) => {
    return targetItems.length > 1 || !!(availableActions && availableActions.refreshExtract);
  },
  createReduxAction: (targetItems: IContentInfo[]) => createExtractRefresh(targetItems, CreateExtractTasksMode.AllowBoth)
};
